import difference from 'lodash/difference';
import isEqual from 'lodash/isEqual';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { constants } from '@hero/configs';
import { useQueries } from '@hero/hooks';

import { CustomFilter } from '../CustomFilter';

function BrandFilter({ parentRef }) {
  const { t } = useTranslation();
  const { addQuery, queries } = useQueries();

  const brandOptions = Object.values(constants?.brands?.data || {})
    .map(b => ({
      label: b.name,
      value: b.categoryId,
      image: b.logo,
      useAsFilter: b.useAsFilter
    }))
    .filter(b => b.useAsFilter);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const categoryIds =
    typeof queries.categoryIds === 'string' ? [queries.categoryIds] : queries.categoryIds;

  useEffect(() => {
    const selectedBrandOptions = brandOptions.filter(b =>
      queries?.categoryIds?.includes?.(b.value)
    );
    if (!isEqual(selectedOptions, selectedBrandOptions)) {
      setSelectedOptions(selectedBrandOptions);
    }
  }, [queries?.categoryIds]);

  const previousSelectedOptions = brandOptions.filter(c => categoryIds?.includes?.(c.value));

  return (
    !!brandOptions?.length && (
      <CustomFilter
        size="md"
        controlWidth={160}
        creatable={false}
        parentRef={parentRef}
        placeholder={t('allBrands')}
        selectedOption={selectedOptions}
        options={brandOptions}
        searchPlaceholder={t('searchBrands')}
        hasMenuSearch
        onChange={sb => setSelectedOptions(sb)}
        styles={{
          placeholder: (provided, state) => {
            if (state.hasValue) {
              return {
                ...provided,
                color: '#0D1E46',
                fontWeight: 700
              };
            }
            return { ...provided, color: '#475F8B' };
          }
        }}
        onApply={() => {
          const pOptionKeys = previousSelectedOptions.map(p => p.value);
          const sOptionKeys = selectedOptions.map(p => p.value);

          const removedOptions = difference(pOptionKeys, sOptionKeys);
          const addedOptions = difference(sOptionKeys, pOptionKeys);

          if (addedOptions.length || removedOptions.length) {
            addQuery(
              'categoryIds',
              Array.from(
                new Set([
                  ...(categoryIds || []).filter(cId => !removedOptions.includes(cId)),
                  ...addedOptions
                ])
              )
            );
          }
        }}
      />
    )
  );
}

export { BrandFilter };
